<template>
<div>
  <HeaderRanking :key="$route.fullPath"/>
  <v-row no-gutters class="white">
    <v-col class="wrapperWidth">
      <div class="widgetContainer">
        <div class="primary--text font-weight-bold topic px-4 px-md-16 my-md-10 my-6 mx-md-8" v-translate>BGC neatly help you to find where to play and who to play with when you need a bit of a change from your home course.</div>
        <v-card class="px-4 px-md-12 py-5 mb-0 mb-md-10 mx-md-12 cardInfo">
          <v-row no-gutters>
            <v-col cols="12" :md="6" v-for="item in dataCard" :key="item" class="d-flex py-2 pr-md-16">
              <icon name="icon-tick" :width="$vuetify.breakpoint.md ? '30' : '24'" :height="$vuetify.breakpoint.md ? '30' : '24'" class="mr-3"/> <span class="pt-1">{{item}}</span>
            </v-col>
          </v-row>
        </v-card>

        <div class="d-none d-md-block">
          <!-- map regain -->
          <v-row no-gutters class="mt-6 pt-4">
            <v-col cols="12" class="mapAbstract">
              <!-- North America -->
              <div class="area areaBlock" v-for="(dataArea, idx) in listArea" :key="idx">
                <AreaHover :dataArea="dataArea"/>
              </div>

            </v-col>
          </v-row>
          <!-- grogress -->
          <v-row no-gutters class="mt-8 mb-14">
            <v-col cols="12" class="d-flex justify-center">
                <div class="borderProgress">
                  <v-row class="wrapperContent">
                    <SpanArea v-for="(item, idx) in listArea.slice(1, listArea.length)" :key="idx"
                    :name="item.name" :widthBox="item.widthBox" :colorPoin="item.colorPoin"/>
                  </v-row>
                </div>
            </v-col>
          </v-row>
        </div>

        <div class="d-md-none">
          <v-expansion-panels flat accordion>
            <router-link :to="{name: 'ranking-worldwide-all'}"
              class="v-expansion-panel-header rounded-0 font-weight-bold black--text"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);"
              v-translate
              >
              Worldwide
            </router-link>
            <v-expansion-panel
               v-for="(dataArea, idx) in listArea.slice(1, listArea.length)" :key="idx"
            >
              <v-expansion-panel-header :style="`border-bottom: 1px solid rgba(0,0,0,0.125)`" class="rounded-0 font-weight-bold">
                {{dataArea.name}}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <AreaHover :dataArea="dataArea"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </v-col>
  </v-row>
  <CookiesModal v-if="!cookieData"/>
</div>
</template>

<script>
import {mapState} from 'vuex';
import SpanArea from '@/components/HomePage/SpanArea';
import HeaderRanking from '@/components/Ranking/HeaderRanking.vue';
import AreaHover from '@/components/HomePage/AreaHover.vue';
import CookiesModal from '@/components/cookies/CookiesModal.vue';
import AssetService from "@/services/AssetService";
export default {
  name: 'Home',
  components: {SpanArea, HeaderRanking, AreaHover, CookiesModal},
  data() {
    return {
      dataCard: [
        this.$gettext('Discover amazing courses'),
        this.$gettext('Share tips and improve your swing'),
        this.$gettext('Get first-hand insights from people who’ve played them'),
        this.$gettext('Keep track of your results & compare your personal stats'),
        this.$gettext('Find like-skilled partners to play with anywhere in the world'),
        this.$gettext('Give your opinion and feedback on every course you played'),
      ],
    }
  },
  computed: {
    cookieData () {
      return localStorage.getItem('cookieData') || null
    },
    listArea() {
      const listArea = this.$store.state.golfcourse.availableZoneAndCountry;
      const areaStyleMap = {
        'north-america': {
          nameClass: 'area-north-america',
          nameIcon: AssetService.imgUrl('mapArea/north-america.png'),
          background: '#93278F',
          backgroundMenu: '#E02AB8',
          col: 6,
          width: 300,
          widthBox: 'width: 90px;',
          colorPoin: 'color: #E02AB8'
        },
        'south-america': {
          nameClass: 'area-latin-america',
          nameIcon: AssetService.imgUrl('mapArea/south-america.png'),
          background: '#93278F',
          backgroundMenu: '#93278F',
          col: 6,
          width: 300,
          widthBox: "width: 100px;",
          colorPoin: "color: #93278F"
        },
        'central-america-caribbean': {
          nameClass: 'area-central-asia',
          nameIcon: AssetService.imgUrl('mapArea/central-america.png'),
          background: '#0FA0A9',
          backgroundMenu: '#0FA0A9',
          col: 3,
          width: 750,
          widthBox: "width: 130px;",
          colorPoin: "color: #0FA0A9"
        },
        'eastern-europe': {
          nameClass: 'area-eastern-europe',
          nameIcon: AssetService.imgUrl('mapArea/eastern-europe.png'),
          background: '#88C845',
          backgroundMenu: '#6BB61D',
          col: 6,
          width: 400,
          widthBox: "width: 110px;",
          colorPoin: "color: #6BB61D"
        },
        'western-europe': {
          nameClass: 'area-western-europe',
          nameIcon: AssetService.imgUrl('mapArea/western-europe.png'),
          background: '#88C845',
          backgroundMenu: '#388E3C',
          col: 3,
          width: 500,
          widthBox: "width: 110px;",
          colorPoin: "color: #388E3C"
        },
        'middle-east': {
          nameClass: 'area-eurasia_middle_east',
          nameIcon: AssetService.imgUrl('mapArea/middle-east.png'),
          background: '#F7931E',
          backgroundMenu: '#F7931E',
          col: 4,
          width: 420,
          widthBox: "width: 113px;",
          colorPoin: "color: #F7931E"
        },
        'africa': {
          nameClass: 'icon-africa',
          nameIcon: AssetService.imgUrl('mapArea/africa.png'),
          background: '#F7931E',
          backgroundMenu: '#D58F27',
          col: 3,
          width: 620,
          widthBox: "width: 90px;",
          colorPoin: "color: #D58F27"
        },
        'south-south-east-asia': {
          nameClass: 'south-asia',
          nameIcon: AssetService.imgUrl('mapArea/south-east.png'),
          background: '#C1272D',
          backgroundMenu: '#F50F0F',
          col: 6,
          width: 300,
          widthBox: "width: 125px;",
          colorPoin: "color: #F50F0F"
        },
        'central-east-asia': {
          nameClass: 'area-far_east_asia',
          nameIcon: AssetService.imgUrl('mapArea/central-east.png'),
          background: '#C1272D',
          backgroundMenu: '#C1272D',
          col: 6,
          width: 300,
          widthBox: "width: 100px;",
          colorPoin: "color: #C1272D"
        },
        'oceania': {
          nameClass: 'area-oceania',
          nameIcon: AssetService.imgUrl('mapArea/oceania.png'),
          background: '#3FA9F5',
          backgroundMenu: '#4D85B9',
          col: 6,
          width: 300,
          widthBox: "width: 90px;",
          colorPoin: "color: #179d4e"
        }
      }
      return listArea.map((item) => {
        if(areaStyleMap[item.slug]) {
          return {...item, ...areaStyleMap[item.slug]}
        } else {
          return item
        }
      });
    },
  },
  methods: {
  },
  mounted() {

  }
}
</script>